// First-touch acquisition context: captured once per browser (never overwritten
// while still fresh), carried in from the marketing site via a single compact
// query param, and forwarded at signup so Mixpanel can attribute
// activation/upgrade by landing page, channel, and country.

const STORAGE_KEY = 'l2it_first_touch';
const QUERY_PARAM = 'ft';


const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

function readStoredRecord() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const record = JSON.parse(raw);
    if (!record || typeof record !== 'object' || !record.data || !record.capturedAt) {
      return null;
    }
    if (Date.now() - record.capturedAt > MAX_AGE_MS) {
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch {
        // ignore
      }
      return null;
    }
    return record;
  } catch {
    return null;
  }
}

function decodeFirstTouchParam(encoded) {
  try {
    const parsed = JSON.parse(decodeURIComponent(window.atob(encoded)));
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}


export function captureFirstTouch() {
  if (readStoredRecord()) {
    return;
  }

  let url;
  try {
    url = new URL(window.location.href);
  } catch {
    return;
  }

  const encoded = url.searchParams.get(QUERY_PARAM);
  if (!encoded) {
    return;
  }

  const captured = decodeFirstTouchParam(encoded);
  if (!captured) {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      data: captured,
      capturedAt: Date.now(),
    }));
  } catch {
    // localStorage unavailable (private mode, quota) — nothing to persist
  }

  url.searchParams.delete(QUERY_PARAM);
  window.history.replaceState(window.history.state, document.title, url.href);
}

// Returns the stored first-touch object (or null if none was ever captured,
// or the captured record has aged past MAX_AGE_MS).
export function getFirstTouch() {
  const record = readStoredRecord();
  return record ? record.data : null;
}
